import { type AssetReturns } from '../types';

/**
 * Asset class returns - these are constants that don't change per portfolio
 * Based on historical data and market expectations
 */
export const ASSET_RETURNS: AssetReturns = {
    'Large Growth': 0.1226,
    'Large Value': 0.1226,
    'Mid Cap': 0.1048,
    'Small Cap': 0.1036,
    'International Equities': 0.0972,
    'Emerging Markets': 0.0948,
    'Real Estate': 0.0933,
    Government: 0.0366,
    Municipal: 0.0422,
    Corporate: 0.0394,
    'High Yield': 0.0641,
    'International Bonds': 0.0394,
    Cash: 0.0179,
};
